export var REQUEST_LIST = 'REQUEST_LIST_NEWS';
export var SUCCESS_LIST = 'SUCCESS_LIST_NEWS';
export var FAILURE_LIST = 'FAILURE_LIST_NEWS';
export var REQUEST_DETAIL = 'REQUEST_DETAIL_NEWS';
export var SUCCESS_DETAIL = 'SUCCESS_DETAIL_NEWS';
export var FAILURE_DETAIL = 'FAILURE_DETAIL_NEWS';